import { NodeSelection, TextSelection } from '@tiptap/pm/state'
import type { Editor } from '@tiptap/react'

export interface BlockState {
  index: number
  count: number
  canRemove: boolean
  canMoveUp: boolean
  canMoveDown: boolean
}

/** İmlecin ya da seçili düğümün ait olduğu üst düzey bloğun konumu ve komşuları. */
export function blockState(editor: Editor): BlockState {
  const { doc, selection } = editor.state
  const index = selection.$from.index(0)
  return {
    index,
    count: doc.childCount,
    // Belge en az bir blok ister: son blok silinemez.
    canRemove: doc.childCount > 1,
    canMoveUp: index > 0,
    canMoveDown: index < doc.childCount - 1,
  }
}

function blockStart(editor: Editor, index: number): number {
  let pos = 0
  for (let child = 0; child < index; child += 1) pos += editor.state.doc.child(child).nodeSize
  return pos
}

export function removeBlock(editor: Editor): void {
  const state = blockState(editor)
  if (!state.canRemove) return
  const start = blockStart(editor, state.index)
  const node = editor.state.doc.child(state.index)
  const tr = editor.state.tr.delete(start, start + node.nodeSize)
  const nearest = Math.min(start, tr.doc.content.size)
  editor.view.dispatch(
    tr.setSelection(TextSelection.near(tr.doc.resolve(nearest), -1)).scrollIntoView(),
  )
  editor.view.focus()
}

/** Bloğu komşusuyla yer değiştirir; seçim taşınan blokta kalır. */
export function moveBlock(editor: Editor, direction: 'up' | 'down'): void {
  const state = blockState(editor)
  const target = direction === 'up' ? state.index - 1 : state.index + 1
  if (target < 0 || target >= state.count) return

  const { doc, selection } = editor.state
  const node = doc.child(state.index)
  const start = blockStart(editor, state.index)
  const neighbour = doc.child(target)
  const insertAt = direction === 'up' ? start - neighbour.nodeSize : start + neighbour.nodeSize

  const tr = editor.state.tr.delete(start, start + node.nodeSize).insert(insertAt, node)
  tr.setSelection(
    selection instanceof NodeSelection
      ? NodeSelection.create(tr.doc, insertAt)
      : TextSelection.near(tr.doc.resolve(insertAt + 1)),
  )
  editor.view.dispatch(tr.scrollIntoView())
  editor.view.focus()
}
